<template>
	<div id="prizeinfo" class="page">
		<div class="prizeinfo">
			<img v-bind:src="prize.image"/>
			<div class="content">
				<p class="tit">恭喜：</p>
				<p><font color="red">{{info.name}}</font> 顺利通过{{info.km}}考试。鉴于您在学车期间始终坚持训练，注重积累。您是我们驾校的骄傲，特此授予您“<font color="red">驾考考神</font>”荣誉称号。</p>
			</div>
			<div class="userinfo">
				<img v-bind:src="userinfo.avatar"/>
				<p>教练：{{userinfo.realname ? userinfo.realname : userinfo.nickname}}</p>
			</div>
			<router-link v-if="!ismine" :to="{path:'/ds',query:{id:info.id,type:'prize',to_user_id:info.from_user_id}}">
				<div class="btn zs">赞赏</div>
			</router-link>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		prize:{},
		info:{},
		userinfo:{},
		ismine:false
	}
  },
  mounted () {
	
  },
  created(){
	  var that = this
	this.$app.pr('api/prize/get',{
		id:this.$route.query.id
	}).then((res) => {
		this.prize = res.data.prize
		this.info = res.data.info
		this.userinfo = res.data.userinfo
		this.ismine = res.data.ismine
	})
	this.$app.pr('/api/common/jsparams',{
		url:this.$store.state.config.jtype ? this.$store.state.config.starturl : window.location.href,
		type:'prize'
	}).then((res) => {
		try{
			wx.config(res.data.shareparam);
			wx.ready(function(){
				wx.onMenuShareAppMessage({
					title:'您有新的奖状',
					desc:res.data.share_desc,
					link:'https://jk.ioccn.com/prizeinfo.php?id='+that.$route.query.id,
					imgUrl:res.data.share_image,
					success:function(){
					}
				});
				wx.onMenuShareTimeline({
					title: '您有新的奖状',
					link: 'https://jk.ioccn.com/prizeinfo.php?id='+that.$route.query.id,
					imgUrl: res.data.share_image
				});
			});
		}catch(e){alert('fx error'+e)}
	});
  },
  methods:{
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#prizeinfo{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.prizeinfo img{
		width:100%;
		height:100vh;
	}
	.content{
		position:absolute;
		z-index:10;
		top:30vw;
		margin:0vw 15vw;
		font-size:4vw;
	}
	.content .tit{
		font-size:4.6vw;
	}
	.userinfo{
		position:absolute;
		top:70vw;
		width:100%;
		z-index:11;
		text-align:center;
	}
	.userinfo img{
		width:16vw;
		height:16vw;
		border-radius:8vw;
	}
	.btn.zs{
		background:linear-gradient(to right, #fa8d60, #e76025);
		height:10vw;
		width:20vw;
		position:absolute;
		top:100vw;
		border-radius:3vw;
		margin-left:-10vw;
		left:50%;
		text-align:Center;
		line-height:10vw;
		color:#FFFFFF;
		font-size:4vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Prizeinfo.vue